// extracted by mini-css-extract-plugin
export default {"root":"ShadeRight__root--DXSrE","inHeader":"ShadeRight__inHeader--jMKwK","noShade":"ShadeRight__noShade--37EjS","root_folder":"ShadeRight__root_folder--23OGy"};